import Box from '@mui/material/Box';
import React from 'react';
import { TextField } from '@mui/material';
import { loginPageStyles } from '../../styles';
import PropTypes from 'prop-types';

const NUMBER_REGEX = /^(|[1-9]\d*)$/;
const SamplesInput = (props) => {
  const classes = loginPageStyles();
  const handleChange = (event) => {
    if (NUMBER_REGEX.test(event.target.value)) {
      const updatedOrders = props.orders.map((element, idx) => {
        return idx === props.index
          ? {
              ...element,
              samples:
                parseInt(event.target.value) > 99 ? '99' : event.target.value,
            }
          : element;
      });
      props.setOrders(updatedOrders);
    }
  };

  return (
    <>
      {props.orders[props.index].type === 'manual' ? (
        <TextField
          id="QTY-[] "
          placeholder="[QTY]"
          size="small"
          className={classes.textField}
          sx={{
            '& .MuiOutlinedInput-root': {
              fontSize: '13px',
              lineHeight: '16px',
            },
          }}
          value={props.value}
          onChange={handleChange}
        />
      ) : (
        <Box
          sx={{
            fontFamily: 'Mulish',
            fontSize: '13px',
            lineHeight: '16px',
            padding: '0px 4px',
          }}
        >
          {props.orders[props.index].samples}
        </Box>
      )}
    </>
  );
};
SamplesInput.propTypes = {
  orders: PropTypes.array.isRequired,
  index: PropTypes.number.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  setOrders: PropTypes.func.isRequired,
};
export default SamplesInput;
